import { lang, l10n } from '@ott/l10n';
import { MAX_NAME_LENGTH, STATUSES } from '../constants/common';

export default function getName(data) {
  const { firstName, lastName, name, email, userStatus: { type: userStatus } = {} } = data;

  if (firstName || lastName) {
    const userIsRuProPremium =
      lang === 'ru' && (userStatus === STATUSES.pro || userStatus === STATUSES.premium);
    if (
      firstName &&
      lastName &&
      userIsRuProPremium &&
      firstName.length + lastName.length <= MAX_NAME_LENGTH
    ) {
      return `${firstName} ${lastName}`;
    }

    if (firstName) {
      return firstName;
    }

    return lastName;
  }

  if (name) {
    return name;
  }

  if (email) {
    return email.split('@')[0];
  }

  return l10n('auth.profileLink');
}
